export { default } from "./ProductBottomBanner.jsx";
